import moment from "moment";
import { memo, useEffect, useRef, useState } from "react";
import { MdPictureInPictureAlt, MdPlayArrow } from "react-icons/md";

export const PictureInPictureVideoComponent = ({ videoPath }) => {
  const [isPipActive, setIsPipActive] = useState(false);
  const vidRef = useRef(null);

  const togglePictureInPictureMode = async () => {
    const video = vidRef.current;
    if (!video) return;
    try {
      // ensure the video is playing; many browsers require it before PiP
      await video.play();
      // request PiP (simple path; we’re not introducing extra branches)
      await video.requestPictureInPicture?.();
      setIsPipActive(true);
    } catch (error) {
      console.error("Error with Picture-in-Picture:", error);
    }
  };

  useEffect(() => {
    const video = vidRef.current;
    if (!video) return;

    const handleEnterPip = () => setIsPipActive(true);
    const handleExitPip = () => setIsPipActive(false);

    // Standard events
    video.addEventListener("enterpictureinpicture", handleEnterPip);
    video.addEventListener("leavepictureinpicture", handleExitPip);

    return () => {
      video.removeEventListener("enterpictureinpicture", handleEnterPip);
      video.removeEventListener("leavepictureinpicture", handleExitPip);
    };
  }, []);

  return (
    <div
      className="relative size-10 cursor-pointer rounded-lg bg-black"
      onClick={togglePictureInPictureMode}
    >
      {isPipActive ? (
        <MdPictureInPictureAlt
          aria-hidden
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          color="white"
          size={20}
        />
      ) : (
        <>
          <video
            className="size-full rounded-lg object-cover"
            controls={false}
            muted
            playsInline
            preload="metadata"
            ref={vidRef}
          >
            <source src={videoPath} type="video/mp4" />
          </video>
          <MdPlayArrow
            aria-hidden
            className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            color="white"
            size={22}
          />
        </>
      )}
    </div>
  );
};

export const PictureInPictureVideo = memo(PictureInPictureVideoComponent);
